export default __webpack_public_path__ + "static/UNAC4-43f85accbddee8309b685592dc98f10e.png";